/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { useTranslation } from "react-i18next";

const WebHiClassInfoEdutech = () => {
    const { t } = useTranslation();

    return (
        <div className="d-flex flex-column w-100" style={{ margin: '10px 0px', wordBreak: 'keep-all', wordWrap: 'break-word' }}>
            <img className="w-100" src="/images/info/edu/edu01.png" alt="HiClassTV_Pentalk_Edu01.png" />
        </div>
    );
}

export default WebHiClassInfoEdutech;